export const NEXTABLE_ERROR_CODE = {
  NO_AVAILABILITY: 100,
  ITEM_NOT_FOUND: 100020,
  TIME_SLOT_UNAVAILABLE: 400
};
